import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { filter, map } from "rxjs";
import { TranslocoPipe } from "@jsverse/transloco";
import { KsgButton, KsgTooltip } from "@ksg/ui";
import { TourService } from "./tour.service";

/**
 * Dyskretny przycisk „Samouczek" w prawym górnym rogu. Widoczny tylko, gdy bieżąca
 * trasa ma zarejestrowany samouczek; uruchamia go jako przewodnik (bez symulacji).
 */
@Component({
  selector: "app-tour-button",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, KsgButton, KsgTooltip],
  templateUrl: "./tour-button.html",
})
export class TourButton {
  private readonly router = inject(Router);
  private readonly tour = inject(TourService);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map(() => this.stripQuery(this.router.url)),
    ),
    { initialValue: this.stripQuery(this.router.url) },
  );

  readonly available = computed(
    () => !!this.tour.tourForRoute(this.currentUrl()),
  );

  start(): void {
    this.tour.startForRoute(this.currentUrl());
  }

  private stripQuery(url: string): string {
    return url.split("?")[0].split("#")[0];
  }
}
